module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCreative.7bc5cfe.jpg";